/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Preferred_Field_Of_StudyInputs */

const en_job_form_preferred_field_of_study = /** @type {(inputs: Job_Form_Preferred_Field_Of_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferred Field of Study`)
};

const de_job_form_preferred_field_of_study = /** @type {(inputs: Job_Form_Preferred_Field_Of_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevorzugtes Studienfeld`)
};

/**
* | output |
* | --- |
* | "Preferred Field of Study" |
*
* @param {Job_Form_Preferred_Field_Of_StudyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_form_preferred_field_of_study = /** @type {((inputs?: Job_Form_Preferred_Field_Of_StudyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Preferred_Field_Of_StudyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_preferred_field_of_study(inputs)
	return en_job_form_preferred_field_of_study(inputs)
});